module.exports = __webpack_public_path__ + "static/assets/1778ff0831ecc75b505067ac7f1e9156.png";